// "Korkem" theme — based on the logo colors (deep blue dominant, red minimal).
// Light, elegant, minimal. Registered alongside the existing dark/light themes
// without modifying them. See src/styles/korkem-theme.scss for accent overrides.
// Google-inspired: clean white background, dark text, minimal borders.
export const korkemTheme = {
  dark: false,
  colors: {
    primary:    '#20439a',  // лого көк
    secondary:  '#245c84',
    accent:     '#fd3231',  // лого қызыл — минимал
    error:      '#fd3231',
    warning:    '#FB8C00',
    info:       '#245c84',
    success:    '#2e7d32',
    background: '#ffffff',   // Google: pure white
    surface:    '#ffffff',
    'on-surface':    '#202124',  // Google text
    'on-background': '#202124',
    'on-primary':    '#ffffff',
    'on-secondary':  '#ffffff',
  },
}
